import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import Typewriter from "typewriter-effect";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div name="home" className="w-full h-screen bg-[#0B0F1F]">
      {/* Container */}
      <div className="max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full ">
        <p className="text-1xl sm:text-2xl text-[#CF6C2F]">
          Hello!!! My name is
        </p>
        <h1 className="text-3xl md:text-7xl font-bold text-[#ccd6f6]">
          Yathin Prakash Kethepalli
        </h1>
        <h2 className="text-2xl md:text-6xl font-bold text-[#8892b0]">
          <Typewriter
            options={{
              strings: [
                "Blockchain Developer",
                "Web Developer",
                "IoT Developer",
                "Educator",
              ],
              autoStart: true,
              loop: true,
              deleteSpeed: 10,
              cursor: "_",
              delay: 50,
              pauseFor: 1500,
            }}
          />
        </h2>
        <p className="text-[#8892b0] py-4 max-w-[700px] ">
          My first choice will always be to groom my career as Blockchain
          Developer. I'm hungry for learning new technologies and have developed
          projects on Ethereum, Polygon, Quorum, Bitgert.
        </p>
        <div>
          <Link to="work" smooth={true} duration={500}>
            <button className="text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-[#CF6C2F] hover:border-[#CF6C2F]">
              View Work
              <span className="group-hover:rotate-90 duration-500">
                <HiArrowNarrowRight className="ml-2" />
              </span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
